webpackJsonp([114276838955818,60335399758886],{

/***/ 114:
/***/ (function(module, exports) {

	module.exports = {"data":{"allContentfulProject":{"edges":[{"node":{"title":"Hand, Mind, and Drawing","slug":"hand-mind-and-drawing"}},{"node":{"title":"Miracle's Coop","slug":"miracles-coop"}},{"node":{"title":"What Mies Told Me 1","slug":"what-mies-told-me"}},{"node":{"title":"What Mies Told Me 2","slug":"what-mies-told-me-2"}},{"node":{"title":"What Mies Told Me 3","slug":"what-mies-told-me-3"}},{"node":{"title":"12x12","slug":"12x12"}},{"node":{"title":"House 6","slug":"house-6"}},{"node":{"title":"Slaughterhouse Event","slug":"slaughterhouse-event"}},{"node":{"title":"Hershey's Korea ","slug":"hersheys-korea"}},{"node":{"title":"Gombal Coffee","slug":"gombal-coffee"}},{"node":{"title":"Objective Non Objective","slug":"objective-non-objective"}},{"node":{"title":"Wrightcraft","slug":"wrightcraft"}},{"node":{"title":"Yellow Scape","slug":"yellow-scape"}},{"node":{"title":"City Scape","slug":"city-scape"}},{"node":{"title":"Double Parc de la Villette","slug":"double-parc-de-la-villette"}},{"node":{"title":"Split Ball","slug":"split-ball"}},{"node":{"title":"Ball in Net","slug":"ball-in-net"}},{"node":{"title":"Jumper","slug":"jumper"}},{"node":{"title":"Transformer","slug":"transformer"}},{"node":{"title":"The A","slug":"the-a"}},{"node":{"title":"Chair 6.0","slug":"chair-6-0"}},{"node":{"title":"Cook 8","slug":"cook-8"}},{"node":{"title":"Sukkah Detroit","slug":"sukkah-detroit"}},{"node":{"title":"OO Stool ","slug":"oo-stool"}},{"node":{"title":"Breathing Books","slug":"breathing-books"}},{"node":{"title":"Five Siblings","slug":"five-siblings"}}]},"site":{"siteMetadata":{"title":"오오건축 - ooarchitecture"}}},"layoutContext":{}}

/***/ }),

/***/ 214:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(218);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(114);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 225:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(235), __esModule: true };

/***/ }),

/***/ 227:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(237), __esModule: true };

/***/ }),

/***/ 231:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(225);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ }),

/***/ 232:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};

/***/ }),

/***/ 235:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(260);
	module.exports = __webpack_require__(14).Object.assign;


/***/ }),

/***/ 237:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(262);
	module.exports = __webpack_require__(14).Object.keys;


/***/ }),

/***/ 250:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys = __webpack_require__(43);
	var gOPS = __webpack_require__(89);
	var pIE = __webpack_require__(59);
	var toObject = __webpack_require__(94);
	var IObject = __webpack_require__(146);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(25)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
	  } return T;
	} : $assign;


/***/ }),

/***/ 254:
/***/ (function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(24);
	var core = __webpack_require__(14);
	var fails = __webpack_require__(25);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ }),

/***/ 260:
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(24);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(250) });


/***/ }),

/***/ 262:
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(94);
	var $keys = __webpack_require__(43);
	
	__webpack_require__(254)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ }),

/***/ 325:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.navigateTo = undefined;
	
	var _extends2 = __webpack_require__(231);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _keys = __webpack_require__(227);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _objectWithoutProperties2 = __webpack_require__(232);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(58);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(83);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(82);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	exports.withPrefix = withPrefix;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(77);
	
	var _propTypes = __webpack_require__(50);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _history = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*global __PREFIX_PATHS__, __PATH_PREFIX__ */
	var pathPrefix = "/";
	if (false) {
	  pathPrefix = __PATH_PREFIX__;
	}
	
	function withPrefix(path) {
	  return normalizePath(pathPrefix + path);
	}
	
	function normalizePath(path) {
	  return path.replace(/^\/\//g, "/");
	}
	
	function createLocation(path, history) {
	  var location = (0, _history.createLocation)(path, null, null, history.location);
	  location.pathname = withPrefix(location.pathname);
	  return location;
	}
	
	var NavLinkPropTypes = {
	  activeClassName: _propTypes2.default.string,
	  activeStyle: _propTypes2.default.object,
	  exact: _propTypes2.default.bool,
	  strict: _propTypes2.default.bool,
	  isActive: _propTypes2.default.func,
	  location: _propTypes2.default.object
	
	  // Set up IntersectionObserver
	};var handleIntersection = function handleIntersection(el, cb) {
	  var io = new window.IntersectionObserver(function (entries) {
	    entries.forEach(function (entry) {
	      if (el === entry.target) {
	        // Check if element is within viewport, remove listener, destroy observer, and run link callback.
	        // MSEdge doesn't currently support isIntersecting, so also test for  an intersectionRatio > 0
	        if (entry.isIntersecting || entry.intersectionRatio > 0) {
	          io.unobserve(el);
	          io.disconnect();
	          cb();
	        }
	      }
	    });
	  });
	  // Add element to the observer
	  io.observe(el);
	};
	
	var GatsbyLink = function (_React$Component) {
	  (0, _inherits3.default)(GatsbyLink, _React$Component);
	
	  function GatsbyLink(props, context) {
	    (0, _classCallCheck3.default)(this, GatsbyLink);
	
	    // Default to no support for IntersectionObserver
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this));
	
	    var IOSupported = false;
	    if (typeof window !== "undefined" && window.IntersectionObserver) {
	      IOSupported = true;
	    }
	
	    var history = context.router.history;
	
	    var to = createLocation(props.to, history);
	
	    _this.state = {
	      path: (0, _history.createPath)(to),
	      to: to,
	      IOSupported: IOSupported
	    };
	    _this.handleRef = _this.handleRef.bind(_this);
	    return _this;
	  }
	
	  GatsbyLink.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this.props.to !== nextProps.to) {
	      var to = createLocation(nextProps.to, history);
	      this.setState({
	        path: (0, _history.createPath)(to),
	        to: to
	      });
	      // Preserve non IO functionality if no support
	      if (!this.state.IOSupported) {
	        ___loader.enqueue(this.state.path);
	      }
	    }
	  };
	
	  GatsbyLink.prototype.componentDidMount = function componentDidMount() {
	    // Preserve non IO functionality if no support
	    if (!this.state.IOSupported) {
	      ___loader.enqueue(this.state.path);
	    }
	  };
	
	  GatsbyLink.prototype.handleRef = function handleRef(ref) {
	    var _this2 = this;
	
	    this.props.innerRef && this.props.innerRef(ref);
	
	    if (this.state.IOSupported && ref) {
	      // If IO supported and element reference found, setup Observer functionality
	      handleIntersection(ref, function () {
	        ___loader.enqueue(_this2.state.path);
	      });
	    }
	  };
	
	  GatsbyLink.prototype.render = function render() {
	    var _this3 = this;
	
	    var _props = this.props,
	        _onClick = _props.onClick,
	        rest = (0, _objectWithoutProperties3.default)(_props, ["onClick"]);
	
	    var El = void 0;
	    if ((0, _keys2.default)(NavLinkPropTypes).some(function (propName) {
	      return _this3.props[propName];
	    })) {
	      El = _reactRouterDom.NavLink;
	    } else {
	      El = _reactRouterDom.Link;
	    }
	
	    return _react2.default.createElement(El, (0, _extends3.default)({
	      onClick: function onClick(e) {
	        // eslint-disable-line
	        _onClick && _onClick(e);
	
	        if (e.button === 0 && // ignore right clicks
	        !_this3.props.target && // let browser handle "target=_blank"
	        !e.defaultPrevented && // onClick prevented default
	        !e.metaKey && // ignore clicks with modifier keys...
	        !e.altKey && !e.ctrlKey && !e.shiftKey) {
	          // Is this link pointing to a hash on the same page? If so,
	          // just scroll there.
	          var pathname = _this3.state.path;
	          if (pathname.split("#").length > 1) {
	            pathname = pathname.split("#").slice(0, -1).join("");
	          }
	          if (pathname === window.location.pathname) {
	            var hashFragment = _this3.state.path.split("#").slice(1).join("#");
	            var element = document.getElementById(hashFragment);
	            if (element !== null) {
	              element.scrollIntoView();
	              return true;
	            } else {
	              // This is just a normal link to the current page so let's emulate default
	              // browser behavior by scrolling now to the top of the page.
	              window.scrollTo(0, 0);
	              return true;
	            }
	          }
	
	          // In production, make sure the necessary scripts are
	          // loaded before continuing.
	          if (true) {
	            e.preventDefault();
	            window.___navigateTo(_this3.state.to);
	          }
	        }
	
	        return true;
	      }
	    }, rest, {
	      to: this.state.to,
	      innerRef: this.handleRef
	    }));
	  };
	
	  return GatsbyLink;
	}(_react2.default.Component);
	
	GatsbyLink.propTypes = (0, _extends3.default)({}, NavLinkPropTypes, {
	  innerRef: _propTypes2.default.func,
	  onClick: _propTypes2.default.func,
	  to: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired
	});
	
	GatsbyLink.contextTypes = {
	  router: _propTypes2.default.object
	};
	
	exports.default = GatsbyLink;
	var navigateTo = exports.navigateTo = function navigateTo(to) {
	  window.___navigateTo(to);
	};

/***/ }),

/***/ 217:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	   var children = _ref.children;
	   return _react2.default.createElement(
	      "div",
	      { className: "body-container" },
	      children
	   );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(325);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(37);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _style = __webpack_require__(312);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _container = __webpack_require__(217);
	
	var _container2 = _interopRequireDefault(_container);
	
	var _get = __webpack_require__(33);
	
	var _get2 = _interopRequireDefault(_get);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Template = function (_React$Component) {
	  _inherits(Template, _React$Component);
	
	  function Template() {
	    _classCallCheck(this, Template);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Template.prototype.render = function render() {
	    var _props = this.props,
	        location = _props.location,
	        children = _props.children;
	
	    var siteTitle = (0, _get2.default)(this.props, 'data.site.siteMetadata.title');
	    var postIndex = (0, _get2.default)(this.props, 'data.allContentfulProject');
	
	    var header = void 0;
	
	    var rootPath = '/';
	    if (false) {
	      rootPath = __PATH_PREFIX__ + '/';
	    }
	
	    var navigation = _react2.default.createElement('div', { className: 'menu', style: { display: 'hidden' } });
	    var projects = _react2.default.createElement(
	      'ul',
	      { className: 'projects' },
	      postIndex.edges.map(function (_ref) {
	        var node = _ref.node;
	
	        return _react2.default.createElement(
	          'li',
	          { key: node.slug },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/project/' + node.slug },
	            node.title
	          )
	        );
	      }),
	      _react2.default.createElement('li', null)
	    );
	    console.log(location.pathname);
	    if (location.pathname !== '/') {
	      var navStyle = null;
	      if (location.pathname === '/project/') {
	        navStyle = { display: 'block' };
	      }
	
	      navigation = _react2.default.createElement(
	        'div',
	        { className: 'menu', style: navStyle },
	        projects,
	        _react2.default.createElement(
	          'ul',
	          { className: 'other-menu' },
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '/drawings/' },
	              'Drawings'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '/contact/' },
	              'Contact'
	            )
	          )
	        )
	      );
	    }
	
	    return _react2.default.createElement(
	      _container2.default,
	      null,
	      _react2.default.createElement(_reactHelmet2.default, { title: siteTitle }),
	      _react2.default.createElement(
	        'div',
	        { className: 'main-pannel' },
	        children(this.props),
	        navigation,
	        _react2.default.createElement(
	          'div',
	          { className: 'main-title' },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/project/' },
	            _react2.default.createElement('img', { src: '/img/logo.png', width: '108', alt: 'logo' })
	          )
	        )
	      )
	    );
	  };
	
	  return Template;
	}(_react2.default.Component);
	
	exports.default = Template;
	var query = exports.query = '** extracted graphql fragment **';

/***/ }),

/***/ 312:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-6a5f7fe6dfd3765f28a7.js